import React, { useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import NavigateBack from 'ui/NavigateBack/NavigateBack';
import accountsStore from 'store/accountsStore';
import { IAccount } from 'store/accounts.model';
import { IScheduleTransfer, TabsType } from './ScheduledTransfers.model';
import BetweenAccounts from './Transfers/BetweenAccounts';
import FirstAtlanticAccounts from './Transfers/FirstAtlanticAccounts';
import AnotherBank from './Transfers/AnotherBank';
import BulkAccounts from './Transfers/BulkAccounts';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ScheduledTransfers.module.css';

type Props = {
  onClose: () => void;
  selectedData: IScheduleTransfer | undefined;
  activeTab: TabsType;
};

const EditScheduleTransfer = ({ onClose, activeTab, selectedData }: Props) => {
  const [accountsList, setAccountsList] = useState<IAccount[]>([]);
  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const { accounts: storeAccounts } = accountsStore;

  useEffect(() => setAccountsList(storeAccounts.filter(({ currency }) => currency === 'GHS')), [storeAccounts]);

  const renderEditView = () => {
    if (activeTab === false) {
      return null;
    }

    if (activeTab === 0) {
      return <BetweenAccounts accounts={accountsList} />;
    }

    if (activeTab === 1) {
      return (
        <FirstAtlanticAccounts accounts={accountsList} selectedData={selectedData} />
      );
    }

    if (activeTab === 2) {
      return <AnotherBank accounts={accountsList} />;
    }

    if (activeTab === 3) {
      return <BulkAccounts accounts={accountsList} />;
    }

    return null;
  };

  return (
    <DashboardCard>
      {!downMdScreen
      && <NavigateBack to="scheduleTransfers" onClick={onClose} className={styles.mb20}>Back</NavigateBack>}
      {renderEditView()}
    </DashboardCard>
  );
};

export default EditScheduleTransfer;
